/* cs-aw5-events -- AW5. Count tool usage, in counts, never rates.

   Reuses the pageview beacon already in theme.liquid: a POST to cs_track whose
   p_path is "/e/<event>". No schema change, no new table, no new credential.
   "/e/" is a reserved prefix and is excluded from every pageview count.

   Attribution for the NEXT page is done with sessionStorage.cs_utm_content,
   which the existing beacon already reads. utm_source is never written -- it is
   how this project separates its own automation from humans.

   Events emitted:
     /e/quiz-start        first answer tapped on the archetype quiz
     /e/quiz-complete     the result panel became visible
     /e/quiz-<archetype>  which verdict (sand|push|cool|bagel|tech|cap)
     /e/quiz-collection   the "your rack" collection link tapped
     /e/quiz-product      the result's product link tapped
     /e/quiz-share        the share sheet opened
     /e/tool-start        a tool's Find/Check button tapped
     /e/tool-complete     a tool printed a verdict
     /e/tool-product      a tool's buy link tapped
   Each carries the tool in cs_utm_content for the next pageview.
*/
(function () {
  if (location.hostname.indexOf('court-sportswear.com') === -1) return;
  var U = 'https://jryeliesxuzzqpsfeolk.supabase.co/rest/v1/rpc/cs_track',
      K = 'sb_publishable_yK6kj_rVckVx8yJAjj_YKw_SoAz1WqQ';

  function sid() {
    try {
      var k = 'cs_sid', v = sessionStorage.getItem(k);
      if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36);
                sessionStorage.setItem(k, v); }
      return v;
    } catch (e) { return 'nostore'; }
  }

  var sent = {};
  function emit(name) {
    if (sent[name]) return;          /* one row per event per page, not per tap */
    sent[name] = 1;
    try {
      var q = new URLSearchParams(location.search);
      fetch(U, {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/json',
                   'apikey': K, 'Authorization': 'Bearer ' + K },
        body: JSON.stringify({
          p_session_id: sid(),
          p_path: '/e/' + name,
          p_referrer: location.pathname,
          p_referrer_host: location.hostname,
          p_utm_source: q.get('utm_source') || '',
          p_utm_medium: q.get('utm_medium') || '',
          p_utm_campaign: q.get('utm_campaign') || '',
          p_device: (window.innerWidth < 768 ? 'mobile' : 'desktop'),
          p_viewport_w: window.innerWidth,
          p_is_new_session: false,
          /* p_utm_content is NOT optional decoration. public.cs_track is
             OVERLOADED on that project -- a 10-arg version and an 11-arg one
             that adds p_utm_content -- and PostgREST cannot choose between
             them, so a 10-argument payload returns HTTP 300 PGRST203 and
             writes nothing. Diagnosed by transacting both shapes: 10 args ->
             300, 11 args -> 204. Sending it pins the 11-arg signature.
             The inline beacon on the archetype quiz page has the same 10-arg
             shape and has therefore been silently discarding every call since
             it shipped -- see reports/BLOCKED.md. */
          p_utm_content: (function () {
            try { return sessionStorage.getItem('cs_utm_content') || ''; }
            catch (e) { return ''; }
          })()
        })
      }).catch(function () {});
    } catch (e) {}
  }

  /* Attribute the NEXT pageview, without ever touching utm_source, and without
     overwriting a utm_content the session genuinely arrived with. */
  function stamp(v) {
    try {
      if (!sessionStorage.getItem('cs_utm_content')) {
        sessionStorage.setItem('cs_utm_content', v);
      }
    } catch (e) {}
  }

  function visible(el) {
    return el && getComputedStyle(el).display !== 'none';
  }

  /* --- the archetype quiz (#cslq) --------------------------------------- */
  var quiz = document.getElementById('cslq');
  if (quiz) {
    quiz.addEventListener('change', function () { emit('quiz-start'); }, true);
    quiz.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a,button') : null;
      if (!a) return;
      if (a.id === 'cslq-coll') { stamp('quiz:collection'); emit('quiz-collection'); }
      else if (a.id === 'cslq-buy') { stamp('quiz:product'); emit('quiz-product'); }
      else if (a.id === 'cslq-share') { emit('quiz-share'); }
    }, true);

    var res = document.getElementById('cslq-res');
    if (res) {
      new MutationObserver(function () {
        if (!visible(res)) return;
        emit('quiz-complete');
        var coll = document.getElementById('cslq-coll');
        var h = coll && coll.getAttribute('href');
        if (h) {
          /* the archetype IS the collection handle; no second source of truth */
          emit('quiz-' + h.split('/').pop());
        }
      }).observe(res, { attributes: true, attributeFilter: ['style', 'class'] });
    }
  }

  /* --- the size finder and the dress-code checker (#csaf) ---------------- */
  var tool = document.getElementById('csaf');
  if (tool) {
    var which = location.pathname.indexOf('size') !== -1 ? 'size' : 'dresscode';
    var go = document.getElementById('csaf-go');
    if (go) go.addEventListener('click', function () { emit('tool-start'); }, true);
    tool.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a') : null;
      if (a && a.id === 'csaf-buy') { stamp('tool:' + which); emit('tool-product'); }
    }, true);
    var tres = document.getElementById('csaf-res');
    if (tres) {
      new MutationObserver(function () {
        if (visible(tres)) emit('tool-complete');
      }).observe(tres, { attributes: true, attributeFilter: ['style', 'class'] });
    }
  }
})();
